export default __webpack_public_path__ + "static/media/PressRoom_Logo.d71d98b9.jpg";